<template>
  <f7-page no-swipeback ref="page">
    <f7-navbar title="庫存管理 Inventories" back-link="返回 Back"></f7-navbar>

    <div class="z-10 fixed bottom-0 right-0 mb-4">
      <div class="flex flex-col items-center bg-white p-2 rounded-l-lg shadow">
        <span class="text-xs">Only Expired</span>
        <f7-toggle :value="onlyExpired ? 1 : 0" @change="() => onlyExpired = !onlyExpired" class="transform scale-75" />
      </div>
    </div>

    <f7-block v-if="loading">
      Loading...
    </f7-block>

    <template v-else>
      <f7-toolbar tabbar scrollable position="top">
        <f7-link
          tab-link
          :tab-link-active="current_root_category_id === 0"
          @click="changeCategory(0)"
        >全部 All</f7-link>
        <f7-link
          v-for="category in categories"
          :key="category.id"
          tab-link
          :tab-link-active="current_root_category_id === category.id"
          @click="changeCategory(category.id)"
        >
          {{ category.name }}
        </f7-link>
      </f7-toolbar>

      <f7-list ref="list" media-list virtual-list>
        <f7-list-group :key="category.category_id" v-for="category in filteredCategoriesProducts">
          <f7-list-item :title="category.category_name" group-title></f7-list-item>

          <f7-list-item
            v-for="product in category.products"
            :key="product.id"
            class="text-orange"
            :link="`/warehouse/products/${product.id}/`"
          >
            <div class="flex items-center justify-between">
              <div>
                <div>{{ product.name }}</div>

                <div class="mt-1 text-sm">
                  單價 ${{ product.price }}
                </div>
              </div>

              <div  v-if="product.manages_inventory" class="flex items-center">
                <div class="whitespace-nowrap text-sm text-right mr-4">
                  <div>庫存: {{ product.inventory_quantity }}</div>
                  <div v-if="product.expired_inventory_quantity > 0">
                    已過期庫存: {{ product.expired_inventory_quantity }}
                  </div>
                </div>

                <div>
                  <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4 text-gray-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5l7 7-7 7" />
                  </svg>
                </div>
              </div>
            </div>
          </f7-list-item>
        </f7-list-group>
      </f7-list>
    </template>
  </f7-page>
</template>

<script>
import axios from 'axios'

export default {
  data: () => ({
    loading: true,
    categories: [],
    categories_products: [],
    current_root_category_id: 1,
    onlyExpired: 0,
  }),

  mounted() {
    this.fetch()
  },

  computed: {
    filteredCategoriesProducts() {
      if (this.categories.length === 0 || this.categories_products.length === 0) {
        return []
      }

      if (this.current_root_category_id === 0) {
        return this.categories_products
      }

      let subcategory_ids = this.categories
                              .find(root => root.id === this.current_root_category_id)
                              .subcategories
                              .map(found => found.id)

      return this.categories_products.filter(category_products => subcategory_ids.includes(category_products.category_id))
    },
  },

  watch: {
    onlyExpired() {
      this.fetch()
    },
  },

  methods: {
    async fetch() {
      this.loading = true

      await axios.get('/api/categories').then(({ data }) => {
        this.categories = data
      })

      axios.get('/api/products', {
        params: {
          filters: {
            expired: this.onlyExpired ? 'only' : 'all',
            manages_inventory: true
          }
        }
      }).then(({ data }) => {
        let subCategories = [...new Set(data.map(product => product.category.id))];

        let structured = subCategories.map((category_id) => {
          let categoryFound = data.find(obj => obj.category.id === category_id)

          return {
            category_id: category_id,
            category_name: categoryFound.category.name,
            products: data.filter((item) => {
              return item.category.id === category_id
            }).map((product) => {
              return {
                id: product.id,
                name: product.name,
                price: (product.price / 100),
                manages_inventory: product.manages_inventory,
                inventory_quantity: product.inventory_quantity,
                expired_inventory_quantity: product.expired_inventory_quantity,
              }
            })
          }
        })

        this.categories_products = structured

        this.loading = false
      })
    },
    changeCategory(categoryId) {
      this.current_root_category_id = categoryId

      this.$nextTick(() => {
        this.$$(this.$refs['page'].$el).find('.page-content')[0].scrollTop = 0
      })
    },
  }
}
</script>
